import { io } from 'socket.io-client';

const subscriptions = new Map();
const joinTimeout = 5000;
const joinRetryDelay = 5000;

const socket = io('https://ws3.slope.es', {
    path: '/realtime',
    transports: ['websocket'],
    withCredentials: true,
});

function clearJoin(subscription) {
    clearTimeout(subscription.timer);
    subscription.timer = null;
    subscription.attempt = null;
}

function joinChannel(channel, subscription) {
    if (!socket.connected || subscription.joined || subscription.attempt || subscriptions.get(channel) !== subscription) {
        return;
    }

    const attempt = {};
    subscription.attempt = attempt;
    const retry = () => {
        if (subscription.attempt !== attempt) return;
        if (!subscription.joinFailureReported) {
            console.warn('Socket channel subscription could not be confirmed; retrying.');
            subscription.joinFailureReported = true;
        }
        clearJoin(subscription);
        subscription.needsRefresh = true;
        subscription.canRecoverRoom = false;
        subscription.timer = setTimeout(() => joinChannel(channel, subscription), joinRetryDelay);
    };
    socket.timeout(joinTimeout).emit('join', { channel }, (error, response) => {
        if (subscription.attempt !== attempt || !socket.connected) return;
        if (error || !response?.ok) {
            retry();
            return;
        }

        clearJoin(subscription);
        subscription.joined = true;
        subscription.joinFailureReported = false;
        // General session recovery only covers rooms that were successfully joined.
        const needsRefresh = subscription.needsRefresh && (!socket.recovered || !subscription.canRecoverRoom);
        subscription.needsRefresh = false;
        if (needsRefresh) {
            subscription.consumers.forEach(consumer => consumer.onReconnect?.());
        }
    });
}

socket.on('connect', () => {
    subscriptions.forEach((subscription, channel) => joinChannel(channel, subscription));
});

socket.on('disconnect', () => {
    subscriptions.forEach(subscription => {
        clearJoin(subscription);
        subscription.canRecoverRoom = subscription.joined;
        subscription.joined = false;
        subscription.needsRefresh = true;
    });
});

function initSocketEvents({ channel, action, onReconnect = undefined }) {
    let subscription = subscriptions.get(channel);
    if (!subscription) {
        subscription = { consumers: new Set(), joined: false, attempt: null, timer: null, needsRefresh: false, canRecoverRoom: false, joinFailureReported: false };
        subscriptions.set(channel, subscription);
    }

    const handler = (response) => action(response.payload);
    const consumer = { onReconnect };
    subscription.consumers.add(consumer);
    socket.on(channel, handler);
    joinChannel(channel, subscription);

    return () => {
        socket.off(channel, handler);
        subscription.consumers.delete(consumer);
        if (subscription.consumers.size === 0 && subscriptions.get(channel) === subscription) {
            clearJoin(subscription);
            subscriptions.delete(channel);
        }
    };
}

function desconectarSocket() {
    socket.disconnect();
}

window.addEventListener('pagehide', desconectarSocket);
window.addEventListener('pageshow', (event) => {
    if (event.persisted) socket.connect();
});

// Exportar globalmente para uso en Twig (scripts inline)
window.socket = socket;
window.initSocketEvents = initSocketEvents;
window.desconectarSocket = desconectarSocket;

// Exportar como módulo ES6 para React
export { 
    socket, 
    initSocketEvents, 
    desconectarSocket
};
